module.exports = __webpack_public_path__ + "static/media/roundCircle.2281f01e.svg";